import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import { useUserStore } from '@/stores/userStore';

export const useRecentSearchesStore = defineStore('recentSearches', () => {
    const recentSearches = ref<{ id: number; name: string }[]>([]);
    const userStore = useUserStore();

    function load() {
        if (!userStore.user?.sub) return;

        const stored = localStorage.getItem(`recentSearches_${userStore.user?.sub}`);
        recentSearches.value = stored ? JSON.parse(stored) : [];
    }

    function add(search: { id: number; name: string, model_priority: number, entity: string }) {
        if (!userStore.user?.sub) return;

        recentSearches.value = [search, ...recentSearches.value.filter(s => s.id !== search.id)].slice(0, 3);
    }

    function clear() {
        recentSearches.value = [];
    }

    // Watch and automatically persist per user
    watch(recentSearches, (newItems) => {
        if (!userStore.user?.sub) return;

        localStorage.setItem(`recentSearches_${userStore.user?.sub}`, JSON.stringify(newItems));
    }, { deep: true });

    return { recentSearches, load, add, clear };
});
